import { DESKTOP_PREVIEW_COMPACT_MEDIA_QUERY } from '../../../../common/components/OfferCardPreview/constants';

// Узкий ли сейчас экран для desktop-превью (фиксируется на момент открытия превью).
export function isCompactDesktopPreview(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  return window.matchMedia(DESKTOP_PREVIEW_COMPACT_MEDIA_QUERY).matches;
}
